import React from "react";

const StatusChangedEmail: React.FC = () => {
    const htmlContent = `
        <div class="flex justify-center py-8 bg-gray-100 rounded-lg">
            <div class="max-w-[600px] mx-auto bg-white shadow-lg">
                <div class="bg-gradient-to-r from-blue-600 to-blue-700 px-8 py-6">
                    <h1 class="text-white text-2xl font-semibold">Service Desk</h1>
                </div>
                <div class="px-8 py-6">
                    <h2 class="text-2xl font-semibold text-gray-900 mb-4">Ticket Status Update</h2>
                    <p class="text-gray-700 mb-6">The status of your support ticket has been updated.</p>
                    <div class="flex items-center gap-8 mb-6 bg-gray-50 p-4 rounded-md">
                        <div class="text-left">
                            <div class="text-xs text-gray-500 mb-1 font-semibold uppercase tracking-wider">Previous Status</div>
                            <span class="inline-block bg-gray-200 text-gray-700 px-3 py-1 rounded text-sm font-medium">In Progress</span>
                        </div>
                        <div class="text-gray-400 text-2xl pt-4">→</div>
                        <div class="text-left">
                            <div class="text-xs text-gray-500 mb-1 font-semibold uppercase tracking-wider">New Status</div>
                            <span class="inline-block bg-red-100 text-red-800 px-3 py-1 rounded text-sm font-medium">Blocked</span>
                        </div>
                    </div>
                    <div class="border-l-4 p-4 mb-4 bg-amber-50 border-amber-200 text-amber-800">
                        <p class="font-semibold mb-1">Ticket is Currently Blocked</p>
                        <p class="text-sm">Additional information or action is required to proceed.</p>
                    </div>
                    <div class="bg-gray-50 p-4 rounded-md mb-6">
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Ticket ID:</span>
                            <span class="text-gray-900"><span class="font-mono text-blue-600">#SD-2024-1547</span></span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Subject:</span>
                            <span class="text-gray-900">Unable to access customer database</span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Updated By:</span>
                            <span class="text-gray-900">Marcus Chen</span>
                        </div>
                        <div class="flex gap-2 mb-2">
                            <span class="font-semibold text-gray-700 min-w-[120px]">Updated At:</span>
                            <span class="text-gray-900">May 6, 2026 at 3:15 PM</span>
                        </div>
                    </div>
                    <div class="mb-6">
                        <h3 class="font-semibold text-gray-900 mb-2">Status Change Note:</h3>
                        <div class="bg-gray-50 p-4 rounded border border-gray-200">
                            <p class="text-gray-700 text-sm">I've identified the issue - your user account needs elevated database permissions. I've submitted a change request to the DBA team (CR-8472). Once approved, I'll apply the permissions and test your access. This typically takes 2-4 hours during business hours.</p>
                        </div>
                    </div>
                    <div class="flex">
                        <a href="#" class="inline-block bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-md font-medium no-underline transition-colors">View Ticket Details</a>
                    </div>
                </div>
                <div class="bg-gray-50 px-8 py-6 border-t border-gray-200">
                    <p class="text-sm text-gray-600">This is an automated message from the Service Desk. Please do not reply directly to this email.</p>
                </div>
            </div>
        </div>
    `;
    return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
};

export default StatusChangedEmail;
